import axios from 'axios';

const url = (type, id) => `/api/v1/analytics/audience/${type}/partnership/${id}`;

export function getFollowers(
  partnershipId,
  contributorIds,
  daysAgo,
  cachedFollowersDataUrl,
  fromCache,
) {
  const source = axios.CancelToken.source();

  let task;

  if (fromCache && cachedFollowersDataUrl) {
    task = axios.get(cachedFollowersDataUrl, {
      cancelToken: source.token,
    });
  } else {
    task = axios.get(url('followers', partnershipId), {
      params: {
        contributor_ids: contributorIds,
        days_ago: daysAgo,
      },
      cancelToken: source.token,
    });
  }

  return [task, source];
}

export function getReaderEvents(
  partnershipId,
  contributorIds,
  daysAgo,
  cachedInvestorTypesDataUrl,
  fromCache,
) {
  const source = axios.CancelToken.source();

  let task;

  if (fromCache && cachedInvestorTypesDataUrl) {
    task = axios.get(cachedInvestorTypesDataUrl, {
      cancelToken: source.token,
    });
  } else {
    task = axios.get(url('investor_types', partnershipId), {
      params: {
        contributor_ids: contributorIds,
        days_ago: daysAgo,
      },
      cancelToken: source.token,
    });
  }

  return [task, source];
}

export function getContributorRanking(
  partnershipId,
  daysAgo,
  cachedContributorRankingDataUrl,
  fromCache,
) {
  const source = axios.CancelToken.source();

  let task;

  if (daysAgo === 0 && fromCache && cachedContributorRankingDataUrl) {
    task = axios.get(cachedContributorRankingDataUrl, {
      cancelToken: source.token,
    });
  } else {
    task = axios.get(url('contributor_ranking', partnershipId), {
      params: { days_ago: daysAgo },
      cancelToken: source.token,
    });
  }

  return [task, source];
}
